import { Link, useSearchParams } from "react-router-dom";
import {
  Typography,
  Box,
  createTheme,
  ThemeProvider,
  Stack,
  Divider,
} from "@mui/material";

import CollectionsTemplate from "../../../components/CollectionsTemplate/index";
import baseTheme from "../../../themes/baseTheme";
import Tooltip from "@mui/material/Tooltip";
import "../Dashboard.css";
import React, { useState, useImperativeHandle, useRef } from "react"


import Status from "../../../stories/StatusComponent/StatusComponent";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import "../../../Localization/i18n";
import { useTranslation } from "react-i18next";

export default function NotificationListitem({ status, headers = [], statusRoleMap, ...props }) {
  status = statusRoleMap[status];
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t } = useTranslation();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const { palette } = baseTheme;
  const theme = createTheme({});
  const padding = "16px 24px";

  return (
    <>

      <Box
        display="flex"
        padding={padding}
        borderBottom="solid 1px"
        borderColor={palette.grey[30]}
        alignItems="center"
      >
        <Box width={headers.find((h) => h.id === "vendorName")}>
          <Typography variant="body2">
            <a
              variant="body2"
              style={{ textDecoration: "none", color: "#2A93DB" }}
              href={"/vendordetails?pqid=" + props?.prequalificationId}
            >
              {props.vendorName}
            </a>
          </Typography>
        </Box>
        <Box width={headers.find((h) => h.id === "Purpose")}>
          <Typography variant="body2">
            {props?.purpose} exp. 
          </Typography>
        </Box>
        <Box width={headers.find((h) => h.id === "Email Sent Date")}>
          <Typography variant="body2">
            {GetfVDateFormate(props?.emailSentDate)}
          </Typography>
        </Box>

        <Box width={headers.find((h) => h.id === "clientName")}>
          <Typography variant="body2">{props?.clientName}</Typography>
        </Box>
        <Box width={headers.find((h) => h.id === "logo")}>

        </Box>
      </Box>

    </>
  );
}